export class RegistrationMdl
{
public InsuredIdNo:string;
public EmailId:string;
public MobileNo:string;
public DOB:string;
public IdExpiry:string;
public IpAddress:string;
public isMobile:boolean;
public Lng:string;
public DeviceType:string;
public Latt:string;
public Lang:string;
public DeviceID:string;
public IsAgreedNotification: boolean;
}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/RegistrationMdl.ts